import { useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { AuthContext } from '@core/providers/AuthProvider';
import { UserOrganizationModel } from '@core/types';

const useChangeOrganizations = () => {
  const { setOrganization } = useContext(AuthContext);

  const queryClient = useQueryClient();

  return ({
    organizationProductId,
    organizations,
  }: {
    userUid?: string;
    organizationProductId: string;
    organizations?: UserOrganizationModel[];
  }) => {
    setOrganization({
      organizationId: organizationProductId,
      hasMoreOrganizations: organizations && organizations?.length > 1,
    });
    queryClient.clear();
    // Force internal viewer state to refresh with new responses
    window.sessionStorage.removeItem('state');
    window.sessionStorage.removeItem('serverUrl');
    window.location.href = '/';
  };
};

export default useChangeOrganizations;
